import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { calculateTimepoint3 } from '../../functions/timepoint.js'
import '../../../styles/assets/css/pages/assessments1.css'
import moment from 'moment'
import { IoIosSquare } from 'react-icons/io'
import WarningIcon from '@material-ui/icons/Warning'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import ScheduleIcon from '@material-ui/icons/Schedule'

class AssessmentList extends Component {
  constructor() {
      super()
      this.state = {
          message: '',
          timeline_start: '',
          now: Math.floor(Date.now() / 1000),
          diff_days: 0,
          mod_days: 0,
          status_assm: {},
          current_week: 0,
          current_month: 0,
          current_trimonth: 0,
          current_sixmonth: 0,
          current_year: 0,
          week_assm: [],
          month_assm: [],
          month_assm_unsc: [],
          trimonth_assm: [],
          trimonth_assm_unsc: [],
          sm_assm: [],
          year_assm: [],
          discharge_assm: [],
          self_stigma_assm: [],
          min_month: 0,
          min_trimonth: 0,
          min_year: 0,
          one_time_tqe: [0, '', 0],
      }
  }

  componentDidMount() {
    this.getTimelineStart2()
  }

  getTimelineStart2 = async () => {
    try {
      const uid = this.props.authReducer.uid;
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      };

      // 1) Fetch enable + timeline in parallel
      const [enableResp, timelineResp] = await Promise.all([
        axios.post(
          connectNode + 'patient/general/get_enable_status_assm',
          { pid: uid },
          { headers }
        ),
        axios.post(
          connectNode + 'patient/assessment/get_timeline_start',
          { uid },
          { headers }
        ),
      ]);

      const status_assm = enableResp.data || {};
      const timeline = timelineResp.data || {};
      const calTimepoint = calculateTimepoint3(timeline);

      // 2) Prebuild containers using computed timepoints
      const safeLen = n => (Number.isFinite(+n) && +n >= 0 ? +n : 0);
      const assmM  = Array.from({ length: safeLen(calTimepoint.current_month)     + 2 }, () => ({ phq9:0, asmr:0, gad7:0, psqi:0, who5:0, providers:0, mtf:0, tqe:0, monthly_status:0 }));
      const assmTM = Array.from({ length: safeLen(calTimepoint.current_trimonth)  + 2 }, () => ({ providers:0, pw18:0, csi:0, final_step:0 }));
      const assmSM = Array.from({ length: safeLen(calTimepoint.current_sixmonth)  + 2 }, () => ({ ders:0, csq8:0, tqe:0 }));
      const assmY  = Array.from({ length: safeLen(calTimepoint.current_year)      + 2 }, () => ({ ders:0 }));

      // 3) Single combined call
      const combinedResp = await axios.post(
        connectNode + 'patient/assessment/get_questionnaire_pt_status',
        {
          uid,
          current_timepointM:  calTimepoint.current_month,    type_timepointM:  'm',
          current_timepointTM: calTimepoint.current_trimonth, type_timepointTM: 'tm',
          current_timepointSM: calTimepoint.current_sixmonth, type_timepointSM: 'sm',
          current_timepointY:  calTimepoint.current_year,     type_timepointY:  'y',
        },
        { headers }
      );

      // 4) Normalize payload shape (supports array OR object)
      const payload = combinedResp.data ?? {};
      let m = [], tm = [], sm = [], y = [], discharge = [], selfStigma = [];
      if (Array.isArray(payload)) {
        [m, tm, sm, y, discharge, selfStigma] = payload;
        m = m || []; tm = tm || []; sm = sm || []; y = y || [];
        discharge = discharge || []; selfStigma = selfStigma || [];
      } else if (payload && typeof payload === 'object') {
        ({
          m = [],
          tm = [],
          sm = [],
          y = [],
          discharge = [],
          selfStigma = [],
        } = payload);
      }

      // 5) Map monthly (scheduled + unscheduled)
      const month_assm_unsc = [];
      (m || []).forEach(each => {
        const tp = Number(each.timepoint);
        if (tp > 0) {
          assmM[tp] ||= { phq9:0, asmr:0, gad7:0, psqi:0, who5:0, providers:0, mtf:0, tqe:0, monthly_status:0 };
          assmM[tp].monthly_status = each.monthly_status || 0;
          if (each.phq9_id  > 0) assmM[tp].phq9  = each.phq9_id;
          if (each.asmr_id  > 0) assmM[tp].asmr  = each.asmr_id;
          if (each.gad7_id  > 0) assmM[tp].gad7  = each.gad7_id;
          if (each.psqi_id  > 0) assmM[tp].psqi  = each.psqi_id;
          if (each.who5_id  > 0) assmM[tp].who5  = each.who5_id;
          if (each.providers_end > 0) assmM[tp].providers = uid;
          if (each.mtf_id   > 0) assmM[tp].mtf   = each.mtf_id;
          if (each.tqe_id  > 0) assmM[tp].tqe  = each.tqe_id;
          else if (each.monthly_status === 2) assmM[tp].mtf = 1;
        } else {
          if (tp <= -9) {
            month_assm_unsc.push({
              tp,
              monthly_status: each.monthly_status,
              start_date_time: each.start_date_time,
              end_date_time: each.end_date_time,
              usc_assign_datetime: each.usc_assign_datetime,
              phq9: each.phq9_id || -1,
              asmr: each.asmr_id || -1,
              gad7: each.gad7_id || -1,
              psqi: each.psqi_id || -1,
              who5: each.who5_id || -1,
              mtf:  each.mtf_id  || (each.monthly_status === 2 ? 1 : -1),
            })
          }
          if (tp == -2) {
            discharge.push({
              tp,
              monthly_status: each.monthly_status,
              start_date_time: each.start_date_time,
              end_date_time: each.end_date_time,
              usc_assign_datetime: each.usc_assign_datetime,
              phq9: each.phq9_id || 0,
              asmr: each.asmr_id || 0,
              gad7: each.gad7_id || 0,
              psqi: each.psqi_id || 0,
              who5: each.who5_id || 0,
              mtf:  each.mtf_id  || (each.monthly_status === 2 ? 1 : 0),
            })
          }
        }
      });

      // 6) Map tri-monthly (scheduled + unscheduled)
      const trimonth_assm_unsc = [];
      (tm || []).forEach(each => {
        const tp = Number(each.timepoint);
        if (tp > 0) {
          assmTM[tp] ||= { providers:0, pw18:0, csi:0, final_step:0 };
          if (each.pw18_id       > 0) assmTM[tp].pw18      = each.pw18_id;
          if (each.providers_id  > 0) assmTM[tp].providers = each.providers_id;
          if (each.csi_id        > 0) assmTM[tp].csi       = each.csi_id;
          if (each.final_step_id > 0) assmTM[tp].final_step= each.final_step_id;
        } else if (tp <= -9) {
          trimonth_assm_unsc.push({
            tp,
            start_date_time: each.start_date_time,
            end_date_time:   each.end_date_time,
            pw18:      each.pw18_id || -1,
            providers: each.providers_id || -1,
            csi:       each.csi_id || -1,
          });
        }
      });

      // 7) Map six-monthly
      (sm || []).forEach(each => {
        const tp = Number(each.timepoint);
        if (tp > 0) {
          assmSM[tp] ||= { ders:0, csq8:0, tqe:0, };
          if (each.ders_id > 0) assmSM[tp].ders = each.ders_id;
          if (each.csq8_id > 0) assmSM[tp].csq8 = each.csq8_id;
          if (each.tqe_id > 0) assmSM[tp].tqe = each.tqe_id;
        }
      });

      // 8) Map yearly
      (y || []).forEach(each => {
        const tp = Number(each.timepoint);
        if (tp > 0 && each.ders_id > 0) {
          assmY[tp] ||= { ders:0 };
          assmY[tp].ders = each.ders_id;
        }
      });

      var get_one_time_qte = [0, '', 0]
      if(timeline.one_time_tqe > 0) {
        get_one_time_qte = [timeline.one_time_tqe, timeline.one_time_tqe_type, timeline.one_time_tqe_tp]
      }

      // 9) Set state once
      this.setState({
        timeline_start: timeline.timeline_start,
        diff_days:   calTimepoint.diff_days,
        mod_days:    calTimepoint.mod_days,
        mod_months:  calTimepoint.mod_months,
        mod_3m:      calTimepoint.mod_3m,
        mod_6m:      calTimepoint.mod_6m,
        mod_years:   calTimepoint.mod_years,
        current_week:     calTimepoint.current_week,
        current_month:    calTimepoint.current_month,
        current_trimonth: calTimepoint.current_trimonth,
        current_sixmonth: calTimepoint.current_sixmonth,
        current_year:     calTimepoint.current_year,
        status_assm,

        min_month:    this.calculateFinishIn5days('m',  timeline.st_month,    timeline.start_month,    timeline.min_month),
        min_trimonth: this.calculateFinishIn5days('tm', timeline.st_trimonth, timeline.start_trimonth, timeline.min_trimonth),
        min_year:     this.calculateFinishIn5days('y',  timeline.st_year,     timeline.start_year,     timeline.min_year),

        month_assm: assmM,
        month_assm_unsc,
        trimonth_assm: assmTM,
        trimonth_assm_unsc,
        sm_assm: assmSM,
        year_assm: assmY,

        one_time_tqe: get_one_time_qte,

        discharge_assm: discharge, //(Array.isArray(discharge) ? discharge[0] : discharge) || {},
        self_stigma_assm: selfStigma || [],
      });
    } catch (err) {
      // optional: surface an error state
      //console.error('getTimelineStart2 error:', err);
      this.setState({ message: 'Failed to load assessments. Please retry.' });
    }
  }

  getTimelineStart = async () => {
    var assm = []
    var assmM = []
    var assmTM = []
    var assmSM = []
    var assmY = []
    var status_assm = {}
    let toState = {}
    // Enable assm //
    await axios({
      method: 'post',
      url: connectNode + 'patient/general/get_enable_status_assm',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.authReducer.uid }
    })
    .then((result) => {
      status_assm = result['data']
    })
    // Timeline //
    var calTimepoint = []
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_timeline_start',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { uid: this.props.authReducer.uid }
    })
    .then((result) => {
      calTimepoint = calculateTimepoint3(result['data'])
      for(var i=-1; i<=calTimepoint.current_month+1; i++) {
        assmM[i] = {phq9: 0, asmr: 0, gad7: 0, psqi: 0, who5: 0, providers: 0, mtf: 0, tqe: 0, monthly_status: 0 }
      }
      for(var i=-1; i<=calTimepoint.current_trimonth+1; i++) {
        assmTM[i] = {providers: 0, pw18: 0, csi: 0, final_step: 0,}
      }
      for(var i=-1; i<=calTimepoint.current_sixmonth+1; i++) {
        assmSM[i] = {ders: 0, csq8: 0, tqe: 0,}
      }
      for(var i=1; i<=calTimepoint.current_year+1; i++) {
        assmY[i] = {ders: 0}
      }

      toState = {
        timeline_start: result['data'].timeline_start,
        diff_days: calTimepoint.diff_days,
        mod_days: calTimepoint.mod_days,
        mod_months: calTimepoint.mod_months,
        mod_3m:      calTimepoint.mod_3m,
        mod_6m: calTimepoint.mod_6m,
        mod_years: calTimepoint.mod_years,
        current_week: calTimepoint.current_week,
        current_month: calTimepoint.current_month,
        current_trimonth: calTimepoint.current_trimonth,
        current_sixmonth: calTimepoint.current_sixmonth,
        current_year: calTimepoint.current_year,
        status_assm: status_assm,
        min_month: this.calculateFinishIn5days('m', result['data'].st_month, result['data'].start_month, result['data'].min_month), //result['data'].min_month < -1 ? result['data'].min_month - 1 : -9,
        min_trimonth: this.calculateFinishIn5days('tm', result['data'].st_trimonth, result['data'].start_trimonth, result['data'].min_trimonth), //result['data'].min_trimonth < -1 ? result['data'].min_trimonth - 1 : -9,
        min_year: this.calculateFinishIn5days('y', result['data'].st_year, result['data'].start_year, result['data'].min_year), //result['data'].min_year < -1 ? result['data'].min_year - 1 : -9,
      }
    })
    // --- Monthly --- //
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_m_list_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        current_timepoint: calTimepoint.current_month,
        type_timepoint: 'm',
       }
    })
    .then((result) => {
      var tp = ''
      result['data'].map(each => {
        tp = each.timepoint
        if(each.monthly_status && tp > 0) {
          assmM[tp].monthly_status = each.monthly_status
          //assm[tp] = {phq4: 0, who5: 0}
          if(each.phq9_id > 0) {
            assmM[tp].phq9 = each.phq9_id
          }
          if(each.asmr_id > 0) {
            assmM[tp].asmr = each.asmr_id
          }
          if(each.gad7_id > 0) {
            assmM[tp].gad7 = each.gad7_id
          }
          if(each.psqi_id > 0) {
            assmM[tp].psqi = each.psqi_id
          }
          if(each.who5_id > 0) {
            assmM[tp].who5 = each.who5_id
          }
          if(each.providers_end > 0) {
            assmM[tp].providers = each.uid
          }
          if(each.mtf_id > 0) {
            assmM[tp].mtf = each.mtf_id
          } else if(each.monthly_status == 2) {
            assmM[tp].mtf = 1
          }
          if(each.tqe_id > 0) {
            assmM[tp].tqe = each.tqe_id
          }
        }
      })
      toState.month_assm = assmM

      var obj_assm = {}
      var buff_m_assm = []
      result['data'].map(each => {
        if(each.timepoint <= -9 && each.timepoint > -20) {
          tp = each.timepoint
          obj_assm = {}
          obj_assm.tp = each.timepoint
          if(each.monthly_status) {
            //assmM[tp].monthly_status = each.monthly_status
            obj_assm.monthly_status = each.monthly_status
            obj_assm.start_date_time = each.start_date_time
            obj_assm.end_date_time = each.end_date_time
            if(each.phq9_id > 0) {
              //assmM[tp].phq9 = each.phq9_id
              obj_assm.phq9 = each.phq9_id
            }
            if(each.asmr_id > 0) {
              //assmM[tp].asmr = each.asmr_id
              obj_assm.asmr = each.asmr_id
            }
            if(each.gad7_id > 0) {
              //assmM[tp].gad7 = each.gad7_id
              obj_assm.gad7 = each.gad7_id
            }
            if(each.psqi_id > 0) {
              //assmM[tp].psqi = each.psqi_id
              obj_assm.psqi = each.psqi_id
            }
            if(each.who5_id > 0) {
              //assmM[tp].psqi = each.psqi_id
              obj_assm.who5 = each.who5_id
            }
            if(each.mtf_id > 0) {
              //assmM[tp].mtf = each.mtf_id
              obj_assm.mtf = each.mtf_id
            } else if(each.monthly_status == 2) {
              //assmM[tp].mtf = 1
              obj_assm.mtf = 1
            }
          }
          buff_m_assm.push(obj_assm)
        } else if(each.timepoint <= -20) {
          tp = each.timepoint
          obj_assm = {}
          obj_assm.tp = each.timepoint
          //if(each.monthly_status) {
            //assmM[tp].monthly_status = each.monthly_status
            obj_assm.monthly_status = each.monthly_status
            obj_assm.start_date_time = each.start_date_time
            obj_assm.end_date_time = each.end_date_time
            obj_assm.usc_assign_datetime = each.usc_assign_datetime
            if(each.phq9_id > 0) {
              //assmM[tp].phq9 = each.phq9_id
              obj_assm.phq9 = each.phq9_id
            }
            if(each.asmr_id > 0) {
              //assmM[tp].asmr = each.asmr_id
              obj_assm.asmr = each.asmr_id
            }
            if(each.gad7_id > 0) {
              //assmM[tp].gad7 = each.gad7_id
              obj_assm.gad7 = each.gad7_id
            }
            if(each.psqi_id > 0) {
              //assmM[tp].psqi = each.psqi_id
              obj_assm.psqi = each.psqi_id
            }
            if(each.who5_id > 0) {
              //assmM[tp].psqi = each.psqi_id
              obj_assm.who5 = each.who5_id
            }
            if(each.mtf_id > 0) {
              //assmM[tp].mtf = each.mtf_id
              obj_assm.mtf = each.mtf_id
            } else if(each.monthly_status == 2) {
              //assmM[tp].mtf = 1
              obj_assm.mtf = 1
            }
          //}
          buff_m_assm.push(obj_assm)
        }

      })
      toState.month_assm_unsc = buff_m_assm

    })
    // --- Trimonthly --- //
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_tm_list_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        current_timepoint: calTimepoint.current_trimonth,
        type_timepoint: 'tm',
       }
    })
    .then((result) => {
      var tp = ''
      var obj_assm = {}
      var buff_tm_assm = []
      var buff_tm_assm_unsc = []
      result['data'].map(each => {
        tp = each.timepoint
        if(tp > 0) {
          if(each.pw18_id > 0) {
            assmTM[tp].pw18 = each.pw18_id
          }
          if(each.providers_id > 0) {
            //assmM[tp].psqi = each.psqi_id
            assmTM[tp].providers = each.providers_id
          }
          if(each.csi_id > 0) {
            //assmM[tp].psqi = each.psqi_id
            assmTM[tp].csi = each.csi_id
          }
          if(each.final_step_id > 0) {
            //assmM[tp].psqi = each.psqi_id
            assmTM[tp].final_step = each.final_step_id
          }
          buff_tm_assm.push(assmTM)
        }
        if(tp <= -9) {
          obj_assm = {}
          obj_assm.tp = each.timepoint
          obj_assm.start_date_time = each.start_date_time
          obj_assm.end_date_time = each.end_date_time
          //assm[tp] = {phq4: 0, who5: 0}

          if(each.pw18_id > 0) {
            //assmTM[tp].pw18 = each.pw18_id
            obj_assm.pw18 = each.pw18_id
          }
          if(each.providers_id > 0) {
            //assmTM[tp].pw18 = each.pw18_id
            obj_assm.providers = each.providers_id
          }
          if(each.csi_id > 0) {
            //assmTM[tp].pw18 = each.pw18_id
            obj_assm.csi = each.csi_id
          }
          buff_tm_assm_unsc.push(obj_assm)
        }
      })
      toState.trimonth_assm = assmTM
      toState.trimonth_assm_unsc = buff_tm_assm_unsc
    })
    // --- Six Month --- //
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_sm_list_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        current_timepoint: calTimepoint.current_sixmonth,
        type_timepoint: 'sm',
       }
    })
    .then((result) => {
      //console.log(result['data'])
      var tp = ''
      result['data'].map(each => {
        tp = each.timepoint
        //assm[tp] = {phq4: 0, who5: 0}
        if(each.ders_id > 0) {
          assmSM[tp].ders = each.ders_id
        }
        if(each.csq8_id > 0) {
          assmSM[tp].csq8 = each.csq8_id
        }
        if(each.tqe_id > 0) {
          assmSM[tp].tqe = each.tqe_id
        }
      })
      toState.sm_assm = assmSM
    })
    // --- Yearly --- //
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_y_list_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        current_timepoint: calTimepoint.current_year,
        type_timepoint: 'y',
       }
    })
    .then((result) => {
      var tp = ''
      result['data'].map(each => {
        tp = each.timepoint
        //assm[tp] = {phq4: 0, who5: 0}
        if(each.ders_id > 0) {
          assmY[tp].ders = each.ders_id
        }
      })
      toState.year_assm = assmY
    })
    // --- Discharge --- //
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_discharge_list_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        current_timepoint: calTimepoint.current_month,
        type_timepoint: 'm',
       }
    })
    .then((result) => {
      toState.discharge_assm = result['data'][0]
    })
    // --- Self Stigma --- //
    await axios({
      method: 'post',
      url: connectNode + 'patient/assessment/check_self_stigma_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.authReducer.uid,
       }
    })
    .then((result) => {
      toState.self_stigma_assm = result['data']
    })
    this.setState(toState)
  }

  calculateFinishIn5days = (type, status, start_timestamp, timepoint) => {
    var val = -9
    const now_timestamp = Math.floor(new Date().getTime()/1000)
    const num5days = 86400 * 5
    //console.log(type + ", " + status + ", " + timepoint + " : "+now_timestamp + " : " + start_timestamp + " , " + (parseFloat(start_timestamp) + parseFloat(num5days)))
    if(timepoint < -1) {
      if(status == 2) {
        val = timepoint - 1
      } else if(status == 1) {

        if(now_timestamp >= (parseFloat(start_timestamp) + parseFloat(num5days))) {
          val = timepoint - 1
        } else {
          val = timepoint
        }
      }
    }
    return val
  }

  addMonths = (date, months) => {
    var d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() != d) {
      date.setDate(0);
    }
    return date;
  }

  genColorStatusM = (current_month, mod_months, val, m, enable_status, m_status) => {
    //console.log(current_month, mod_months, val, m, enable_status, m_status)
    var style = ''
    if(val > 0 || m_status == 2) {
      style = 'completed each_assm1'
    } else {
      if(m < current_month) {
        style = 'past_due each_assm1'
      } else {
        if(enable_status == 1) {
          if(mod_months >= -5 && mod_months <= 0) {
            style = 'due_soon each_assm1'
          } else if(mod_months > 0 && mod_months <= 5){
            style = 'due_now each_assm1'
          } else {
            style = 'past_due each_assm1'
          }
        } else {
          style = 'past_due each_assm1'
        }
      }
    }
    return style
  }

  genColorStatusMusc = (assigned_date, val, m, enable_status, m_status) => {
    //console.log(current_month, mod_months, val, m, enable_status, m_status)
    const date1 = new Date(assigned_date)
    const date2 = new Date()
    const diffTime = Math.abs(date2 - date1)
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
    var style = ''
    if(val > 0) {
      style = 'completed each_assm1'
    } else {
      if (assigned_date && diffDays >= 0 && diffDays <= 7) {
        style = 'due_soon each_assm1'
      } else if (assigned_date && !m_status && diffDays > 7 && diffDays <= 14) {
        style = 'due_now each_assm1'
      } else if (assigned_date && !m_status && diffDays > 14) {
        style = 'past_due each_assm1'
      } else {
        if(val > 0) {
          style = 'completed each_assm1'
        } else {
          style = 'past_due each_assm1'
        }
      }
    }
    return style
  }

  genColorStatusTM = (current_month, mod_months, val, m) => {
    //console.log(current_month, mod_months, val, m)
    var style = ''
    if(val > 0) {
      style = 'completed each_assm1'
    } else {
      if(m < current_month) {
        style = 'past_due each_assm1'
      } else {
        if(mod_months >= -5 && mod_months <= 0) {
          style = 'due_soon each_assm1'
        } else if(mod_months > 0 && mod_months <= 5){
          style = 'due_now each_assm1'
        } else {
          style = 'past_due each_assm1'
        }
      }
    }
    return style
  }

  genColorStatusTMprovider = (current_month, mod_months, val, valCSI, m) => {
    var style = ''
    if(val > 0 || valCSI > 0) {
      style = 'completed each_assm1'
    } else {
      if(m < current_month) {
        style = 'past_due each_assm1'
      } else {
        if(mod_months >= -5 && mod_months <= 0) {
          style = 'due_soon each_assm1'
        } else if(mod_months > 0 && mod_months <= 5){
          style = 'due_now each_assm1'
        } else {
          style = 'past_due each_assm1'
        }
      }
    }
    return style
  }

  genColorStatusSM = (current_year, mod_years, val, m) => {
    var style = ''
    if(val > 0) {
      style = 'completed each_assm1'
    } else {
      if(m < current_year) {
        style = 'past_due each_assm1'
      } else {
        if(mod_years >= -5 && mod_years <= 0) {
          style = 'due_soon each_assm1'
        } else if(mod_years > 0 && mod_years <= 5){
          style = 'due_now each_assm1'
        } else {
          style = 'past_due each_assm1'
        }
      }
    }
    return style
  }

  genColorStatusY = (current_year, mod_years, val, m) => {
    var style = ''
    if(val > 0) {
      style = 'completed each_assm1'
    } else {
      if(m < current_year) {
        style = 'past_due each_assm1'
      } else {
        if(mod_years >= -5 && mod_years <= 0) {
          style = 'due_soon each_assm1'
        } else if(mod_years > 0 && mod_years <= 5){
          style = 'due_now each_assm1'
        } else {
          style = 'past_due each_assm1'
        }
      }
    }
    return style
  }

  genColorSelfStigma = (status, available_date_end) => {
    var now = new Date(),
    today = now.toISOString().substring(0,10)
    var style = ''
    if(status == 1) {
      style = 'completed each_assm1'
    } else {
      if(today <= available_date_end) {
        style = 'due_now each_assm1'
      } else {
        style = 'past_due each_assm1'
      }
    }
    return style
  }

  render() {
    var w_assm = this.state.week_assm
    var m_assm = this.state.month_assm
    var tm_assm = this.state.trimonth_assm //.reverse()
    var tm_assm_unsc = this.state.trimonth_assm_unsc
    var sm_assm = this.state.sm_assm
    var y_assm = this.state.year_assm

    var dateMoment = moment(new Date(this.state.timeline_start*1000), "MM-DD-YYYY")
    var dateMomentTM = moment(new Date(this.state.timeline_start*1000), "MM-DD-YYYY")
    var dateMoment6M = moment(new Date(this.state.timeline_start*1000), "MM-DD-YYYY")
    var dateMomentY = moment(new Date(this.state.timeline_start*1000), "MM-DD-YYYY")

    const today = new Date()
    const tqeStartDate = new Date('2026-01-27T00:00:00')
    return (
      <div className="assessment_list box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
          Questionnaires: Status
          </div>
          { typeof this.props.locationReducer.txt_message !== 'undefined' &&
            this.props.locationReducer.txt_message !== '' &&
            <div className={ (this.props.locationReducer.route === 'assessment_list_1' && "small-12 columns warning_msg8")
              || (this.props.locationReducer.route === 'assessment_list_2' && "small-12 columns warning_msg6")}>
              <div className="float_left1">
              { this.props.locationReducer.route === 'assessment_list_1' && <CheckCircleOutlineIcon />}
              { this.props.locationReducer.route === 'assessment_list_2' && <WarningIcon />}
              </div>
              <div className="txt_warning_msg1">{ this.props.locationReducer.txt_message }</div>
            </div>
          }
          <div className="small-12 columns mod_2">
            <span className="due_soon_color"><IoIosSquare /> Due soon</span>
            <span className="due_now_color"><IoIosSquare /> Due now</span>
            <span className="due_complete_color"><IoIosSquare /> Complete</span>
            <span className="due_past_color"><IoIosSquare /> Past Due</span>
          </div>
          <div className="small-12 columns">
            <div className="row mod_1 space_top1">
              <div className="small-12 columns topic1">
                Questionnaire Schedule
              </div>
              <div className="small-12 columns">
              { [...Array(this.state.current_month)].map((e, i) =>
                <div className="row each_month1" key={'m'+i} >
                  <div className="small-12 medium-4 columns each_assm_txt1 no_right_space1">
                    <CalendarTodayIcon /> <span className="space_right1">Month {i+1}</span>
                    <ScheduleIcon /> { dateMoment.add(1, 'M').format('MM/DD/YYYY')}
                  </div>
                  <div className="small-12 medium-8 columns no-padding-right each_assm_link">
                    {((this.state.current_month == (i+1) && this.state.status_assm.m_phq9 == 1) || m_assm[i+1].phq9 > 0 ||
                      (this.state.current_month > (i+1) && m_assm[i+1].phq9 == 0)) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, m_assm[i+1].phq9, (i+1), this.state.status_assm.m_phq9, this.state.status_assm.monthly_status) : ''}>
                    {m_assm.length > 0 && (m_assm[i+1].phq9 > 0 || (this.state.current_month == (i+1) && this.state.status_assm.m_phq9 == 1)) &&
                      <a href={"/member/assessment/phq9/m/"+(i+1)}>PHQ-9</a>}
                    {m_assm.length > 0 && this.state.current_month == (i+1) && this.state.status_assm.m_phq9 == 0 && '-'}
                    {m_assm.length > 0 && this.state.current_month > (i+1) && m_assm[i+1].phq9 == 0 && 'PHQ-9'}
                    </div>}
                    {((this.state.current_month == (i+1) && this.state.status_assm.m_asrm == 1) || m_assm[i+1].asmr > 0 ||
                      (this.state.current_month > (i+1) && m_assm[i+1].asmr == 0)) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, m_assm[i+1].asmr, (i+1), this.state.status_assm.m_asrm, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && (m_assm[i+1].asmr > 0 || (this.state.current_month == (i+1) && this.state.status_assm.m_asrm == 1)) &&
                        <a href={"/member/assessment/asrm/m/"+(i+1)}>ASMR</a>}
                      {m_assm.length > 0 && this.state.current_month == (i+1) && this.state.status_assm.m_asrm == 0 && '-'}
                      {m_assm.length > 0 && this.state.current_month > (i+1) && m_assm[i+1].asmr == 0 && 'ASMR'}
                    </div>}
                    {((this.state.current_month == (i+1) && this.state.status_assm.m_gad7 == 1) || m_assm[i+1].gad7 > 0 ||
                      (this.state.current_month > (i+1) && m_assm[i+1].gad7 == 0)) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, m_assm[i+1].gad7, (i+1), this.state.status_assm.m_gad7, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && (m_assm[i+1].gad7 > 0 || (this.state.current_month == (i+1) && this.state.status_assm.m_gad7 == 1)) &&
                        <a href={"/member/assessment/gad7/m/"+(i+1)}>GAD-7</a>}
                      {m_assm.length > 0 && this.state.current_month == (i+1) && this.state.status_assm.m_gad7 == 0 && '-'}
                      {m_assm.length > 0 && this.state.current_month > (i+1) && m_assm[i+1].gad7 == 0 && 'GAD-7'}
                    </div>}
                    {((this.state.current_month == (i+1) && this.state.status_assm.m_psqi == 1) || m_assm[i+1].psqi > 0 ||
                      (this.state.current_month > (i+1) && m_assm[i+1].psqi == 0)) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, m_assm[i+1].psqi, (i+1), this.state.status_assm.m_psqi, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && (m_assm[i+1].psqi > 0 || (this.state.current_month == (i+1) && this.state.status_assm.m_psqi == 1)) &&
                        <a href={"/member/assessment/psqi/m/"+(i+1)}>PSQI</a>}
                      {m_assm.length > 0 && this.state.current_month == (i+1) && this.state.status_assm.m_psqi == 0 && '-'}
                      {m_assm.length > 0 && this.state.current_month > (i+1) && m_assm[i+1].psqi == 0 && 'PSQI'}
                    </div>}
                    {((this.state.current_month == (i+1) && this.state.status_assm.m_who5 == 1) || m_assm[i+1].who5 > 0 ||
                      (this.state.current_month > (i+1) && m_assm[i+1].who5 == 0)) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, m_assm[i+1].who5, (i+1), this.state.status_assm.m_who5, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && (m_assm[i+1].who5 > 0 || (this.state.current_month == (i+1) && this.state.status_assm.m_who5 == 1)) &&
                        <a href={"/member/assessment/who5/m/"+(i+1)}>WHO-5</a>}
                      {m_assm.length > 0 && this.state.current_month == (i+1) && this.state.status_assm.m_who5 == 0 && '-'}
                      {m_assm.length > 0 && this.state.current_month > (i+1) && m_assm[i+1].who5 == 0 && 'WHO-5'}
                    </div>}
                    {((this.state.current_month == (i+1) && this.state.status_assm.m_mtf == 1) || m_assm[i+1].mtf > 0 ||
                      (this.state.current_month > (i+1) && m_assm[i+1].mtf == 0)) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, m_assm[i+1].mtf, (i+1), this.state.status_assm.m_mtf, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && (m_assm[i+1].mtf > 0 || (this.state.current_month == (i+1) && this.state.status_assm.m_mtf == 1)) &&
                        <a href={"/member/assessment/mtf/m/"+(i+1)}>MTF</a>}
                      {m_assm.length > 0 && this.state.current_month == (i+1) && this.state.status_assm.m_mtf == 0 }
                      {m_assm.length > 0 && this.state.current_month > (i+1) && m_assm[i+1].mtf == 0 && 'MTF'}
                    </div>}

                    {((i + 1) % 6 !== 0) && ((this.state.current_month == (i+1) && this.state.one_time_tqe[0] === 0) ||
                      (this.state.one_time_tqe[0] > 0 && this.state.one_time_tqe[1] == 'm' && this.state.one_time_tqe[2] == (i+1))) && (() => {
                      //const smIdx = Math.floor((i + 1) / 6);      // ✅ integer
                      //const smRow = sm_assm[smIdx] || { tqe: 0 }; // ✅ safe fallback
                      return (
                        <div
                          className={"top_space1 "+ (m_assm.length > 0 ? this.genColorStatusM(this.state.current_month, this.state.mod_months, this.state.one_time_tqe[0], (i+1), 1, this.state.status_assm.monthly_status) : '') } >
                          <a href={`/member/assessment/tqe/m/${i+1}`}>
                            Trackers and Questionnaires Experience
                          </a>
                        </div>
                      );
                    })()}

                    {((i+1)%3 == 0) && <>
                      <div className={"top_space1 " + (tm_assm.length > 0 ? this.genColorStatusTM(this.state.current_trimonth, this.state.mod_3m, tm_assm[((i+1)/3)].pw18, ((i+1)/3)) : '')}>
                        {tm_assm.length > 0 && (tm_assm[((i+1)/3)].pw18 > 0 || (this.state.current_trimonth == (((i+1)/3)) && this.state.status_assm.twelve_m_well_being == 1)) &&
                          <a href={"/member/assessment/pw18/tm/"+((i+1)/3)}>Well-Being</a>}
                        {tm_assm.length > 0 && this.state.current_trimonth == ((i+1)/3) && this.state.status_assm.twelve_m_well_being == 0 && '-'}
                        {tm_assm.length > 0 && this.state.current_trimonth > ((i+1)/3) && tm_assm[((i+1)/3)].pw18 == 0 && 'Well-Being'}
                      </div>
                      <div className={"top_space1 " + (tm_assm.length > 0 ? this.genColorStatusTMprovider(this.state.current_trimonth, this.state.mod_3m, tm_assm[((i+1)/3)].providers, tm_assm[((i+1)/3)].csi, ((i+1)/3)) : '')}>
                        {tm_assm.length > 0 && (tm_assm[((i+1)/3)].providers > 0 || (this.state.current_trimonth == ((i+1)/3))) &&
                          <a href={"/member/assessment/providers/tm/"+((i+1)/3)}>Providers</a>}
                        {tm_assm.length > 0 && this.state.current_trimonth == ((i+1)/3) && this.state.status_assm.m_providers == 0 && '-'}
                        {tm_assm.length > 0 && this.state.current_trimonth > ((i+1)/3) && tm_assm[((i+1)/3)].providers == 0 && (tm_assm[((i+1)/3)].providers == 0) && 'Providers'}
                      </div>
                      <div className={"top_space1 " + (tm_assm.length > 0 ? this.genColorStatusTM(this.state.current_trimonth, this.state.mod_3m, tm_assm[((i+1)/3)].csi, ((i+1)/3)) : '')}>
                        {tm_assm.length > 0 && (tm_assm[((i+1)/3)].csi > 0 || (this.state.current_trimonth == ((i+1)/3))) &&
                          <a href={"/member/assessment/csi/tm/"+((i+1)/3)}>CSI</a>}
                        {tm_assm.length > 0 && this.state.current_trimonth == ((i+1)/3) && this.state.status_assm.m_csi == 0 && '-'}
                        {tm_assm.length > 0 && this.state.current_trimonth > ((i+1)/3) && 'CSI'}
                      </div>
                      <div className={"txt_smaller1 top_space1 " + (tm_assm.length > 0 ? this.genColorStatusTM(this.state.current_trimonth, this.state.mod_3m, tm_assm[((i+1)/3)].final_step, ((i+1)/3)) : '')} >
                        {tm_assm.length > 0 && (tm_assm[((i+1)/3)].final_step > 0 || (this.state.current_trimonth == ((i+1)/3))) &&
                          <a href={"/member/assessment/final_step/tm/"+((i+1)/3)}>Treatment Response & Major Life Events</a>}
                        {tm_assm.length > 0 && this.state.current_trimonth == ((i+1)/3) && this.state.status_assm.m_final_step == 0 && '-'}
                        {tm_assm.length > 0 && this.state.current_trimonth > ((i+1)/3) && 'Treatment Response and Major Life Events'}
                      </div>
                    </>}

                    {((i+1)%6 == 0) && (<>
                      <div className={"top_space1 "+(sm_assm.length > 0 ? this.genColorStatusSM(this.state.current_sixmonth, this.state.mod_6m, sm_assm[((i+1)/6)].ders, ((i+1)/6)) : '')}>
                        <a href={"/member/assessment/ders18/sm/"+((i+1)/6)}>DERS</a>
                      </div>
                      <div className={"top_space1 "+(sm_assm.length > 0 ? this.genColorStatusSM(this.state.current_sixmonth, this.state.mod_6m, sm_assm[((i+1)/6)].csq8, ((i+1)/6)) : '')}>
                        <a href={"/member/assessment/csq8/sm/"+((i+1)/6)}>CSQ-8</a>
                      </div>
                      {( ((this.state.one_time_tqe[1] === "m" && ((i + 1) - this.state.one_time_tqe[2]) >= 3) ||
                           this.state.one_time_tqe[1] === "sm" || this.state.one_time_tqe[1] === "" )
                          && dateMoment.clone().isSameOrAfter(moment(tqeStartDate)) ) && (
                      <div className={"top_space1 "+(sm_assm.length > 0 ? this.genColorStatusSM(this.state.current_sixmonth, this.state.mod_6m, sm_assm[((i+1)/6)].tqe, ((i+1)/6)) : '')}>
                        {sm_assm.length > 0 && (sm_assm[((i+1)/6)].tqe > 0 || this.state.current_sixmonth == ((i+1)/6)) &&
                          <a href={"/member/assessment/tqe/sm/"+((i+1)/6)}>Trackers and Questionnaires Experience</a>}
                        {sm_assm.length > 0 && this.state.current_sixmonth > ((i+1)/6) && sm_assm[((i+1)/6)].tqe == 0 &&
                          'Trackers and Questionnaires Experience'}
                      </div>)}
                    </>)}
                  </div>
                  {(i > 0) && <div className="sep_line4">&nbsp;</div>}
                </div>
              ).reverse() }
              { this.state.month_assm_unsc.map((each, i) =>
                <div className="row each_month1" key={'m'+i} >
                  <div className="small-12 medium-4 columns each_assm_txt1 no_right_space1">
                    {each.tp > 0 && <><CalendarTodayIcon /> <span className="space_right1">Month {each.tp}</span></>}
                    {each.tp <= -9 && <><span className="space_right1">Unscheduled</span></>}
                    {each.tp > 0 && <><ScheduleIcon /> { moment(new Date(this.state.timeline_start*1000), "MM-DD-YYYY").add(each.tp, 'M').format('MM/DD/YYYY')}</>}
                    {each.tp <= -9 && each.tp > -20 && <><ScheduleIcon /> {each.start_date_time}</>}
                    {each.tp <= -20 && <><ScheduleIcon /> {each.usc_assign_datetime}</>}
                  </div>
                  <div className="small-12 medium-8 columns no-padding-right each_assm_link">
                    {((this.state.status_assm.m_phq9 == 1) || each.phq9 > 0) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusMusc(each.usc_assign_datetime, each.phq9, each.tp, this.state.status_assm.m_phq9, this.state.status_assm.monthly_status) : ''}>
                    {m_assm.length > 0 && each.phq9 >= 0 && <a href={"/member/assessment/phq9/m/"+each.tp}>PHQ-9</a>}
                    {m_assm.length > 0 && each.phq9 == -1 && 'PHQ-9'}
                    </div>}
                    {((this.state.status_assm.m_asrm == 1) || each.asmr > 0) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusMusc(each.usc_assign_datetime, each.asmr, each.tp, this.state.status_assm.m_asrm, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && each.asmr >= 0  && <a href={"/member/assessment/asrm/m/"+each.tp}>ASMR</a>}
                      {m_assm.length > 0 && each.asmr == -1 && 'ASMR'}
                    </div>}
                    {((this.state.status_assm.m_gad7 == 1) || each.gad7 > 0) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusMusc(each.usc_assign_datetime, each.gad7, each.tp, this.state.status_assm.m_gad7, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && each.gad7 >= 0 && <a href={"/member/assessment/gad7/m/"+each.tp}>GAD-7</a>}
                      {m_assm.length > 0 && each.gad7 == -1 && 'GAD-7'}
                    </div>}
                    {((this.state.status_assm.m_psqi == 1) || each.psqi > 0) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusMusc(each.usc_assign_datetime, each.psqi, each.tp, this.state.status_assm.m_psqi, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && each.psqi >= 0 && <a href={"/member/assessment/psqi/m/"+each.tp}>PSQI</a>}
                      {m_assm.length > 0 && each.psqi == -1 && 'PSQI'}
                    </div>}
                    {((this.state.status_assm.m_who5 == 1) || each.who5 > 0) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusMusc(each.usc_assign_datetime, each.who5, each.tp, this.state.status_assm.m_who5, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && each.who5 >= 0 && <a href={"/member/assessment/who5/m/"+each.tp}>WHO-5</a>}
                      {m_assm.length > 0 && each.who5 == -1 && 'WHO-5'}
                    </div>}
                    {((this.state.status_assm.m_mtf == 1) || each.mtf > 0) &&
                    <div className={m_assm.length > 0 ? this.genColorStatusMusc(each.usc_assign_datetime, each.mtf, each.tp, this.state.status_assm.m_mtf, this.state.status_assm.monthly_status) : ''}>
                      {m_assm.length > 0 && each.mtf >= 0 && <a href={"/member/assessment/mtf/m/"+each.tp}>MTF</a>}
                      {m_assm.length > 0 && each.mtf == -1 && 'MTF'}
                    </div>}
                  </div>
                </div>
              ) .reverse() }
              </div>
            </div>
          </div>

          {this.state.self_stigma_assm[0] && this.state.self_stigma_assm[0].id>0 &&
          <div className="small-12 columns">
            <div className="row mod_1 space_top1">
              <div className="small-12 columns topic1">
                Self Stigma
              </div>

              <div className="small-12 columns month_scroll">
              { this.state.self_stigma_assm.map(each =>
                <div className="row each_week1" key={'ss'+each.id} >
                  <div className="small-6 medium-6 columns each_assm_txt1">
                    <ScheduleIcon /> { each.available_date_begin }
                  </div>
                  <div className="small-6 medium-6 columns no-padding-right each_assm_link">
                    <div className={this.genColorSelfStigma(each.sccs_status, each.available_date_end)}>
                      <a href={"/member/assessment/self_stigma/sccs/"+each.id}>SCCS</a>
                    </div>
                    <div className={this.genColorSelfStigma(each.ismi_status, each.available_date_end)}>
                      <a href={"/member/assessment/self_stigma/ismi/"+each.id}>ISMI</a>
                    </div>
                  </div>
                </div>
              )}
              </div>
            </div>
          </div>}

          {(this.state.status_assm.p_status == 6 || this.state.status_assm.p_status == 16 || this.state.status_assm.p_status == 17) &&
          <div className="small-12 columns">
            <div className="row mod_1 space_top1">
              <div className="small-12 columns topic1">
                Discharge Questionnaires
              </div>
              <div className="small-12 columns month_scroll">
                <div className="small-12 medium-10 columns no-padding-right each_assm_link">

                  <div className={(this.state.discharge_assm.phq9_id > 0 && 'completed each_assm1') ||
                  (this.state.discharge_assm.phq9_id == null && 'due_now each_assm1')}>
                  <a href={"/member/assessment/overview/m/-2"}>PHQ-9</a>
                  </div>

                  <div className={(this.state.discharge_assm.asmr_id > 0 && 'completed each_assm1') ||
                  (this.state.discharge_assm.asmr_id == null && 'due_now each_assm1')}>
                  <a href={"/member/assessment/asrm/m/-2"}>ASRM</a>
                  </div>

                  <div className={(this.state.discharge_assm.gad7_id > 0 && 'completed each_assm1') ||
                  (this.state.discharge_assm.gad7_id == null && 'due_now each_assm1')}>
                  <a href={"/member/assessment/gad7/m/-2"}>GAD-7</a>
                  </div>

                  <div className={(this.state.discharge_assm.psqi_id > 0 && 'completed each_assm1') ||
                  (this.state.discharge_assm.psqi_id == null && 'due_now each_assm1')}>
                  <a href={"/member/assessment/psqi/m/-2"}>PSQI</a>
                  </div>

                  <div className={(this.state.discharge_assm.who5_id > 0 && 'completed each_assm1') ||
                  (this.state.discharge_assm.who5_id == null && 'due_now each_assm1')}>
                  <a href={"/member/assessment/who5/m/-2"}>WHO-5</a>
                  </div>

                  <div className={(this.state.discharge_assm.csq8_id > 0 && 'completed each_assm1') ||
                  (this.state.discharge_assm.csq8_id == null && 'due_now each_assm1')}>
                  <a href={"/member/assessment/csq8/m/-2"}>CSQ-8</a>
                  </div>

                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentList)
